export class Storage
{
    labID: string;
    storageName: string; 
    processStep : string; 
    description : string;  
    plateIDs:string[];
    active:boolean;
    version: number;
}